function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import { defineHidden, is, createInterpolator, eachProp, hasFluidValue, getFluidValue, each, isAnimatedString, useForceUpdate, useLayoutEffect, addFluidObserver, removeFluidObserver, raf, useOnce } from "@react-spring/shared";
import * as React from "react";
import { forwardRef, useRef, useCallback, useEffect } from "react";
var $node = Symbol.for("Animated:node");
var isAnimated = function(value) {
    return !!value && value[$node] === value;
};
var getAnimated = function(owner) {
    return owner && owner[$node];
};
var setAnimated = function(owner, node) {
    return defineHidden(owner, $node, node);
};
var getPayload = function(owner) {
    return owner && owner[$node] && owner[$node].getPayload();
};
var Animated = /*#__PURE__*/ function() {
    "use strict";
    function Animated() {
        _classCallCheck(this, Animated);
        this.payload = void 0;
        setAnimated(this, this);
    }
    _createClass(Animated, [
        {
            key: "getPayload",
            value: function getPayload() {
                return this.payload || [];
            }
        }
    ]);
    return Animated;
}();
var AnimatedValue = /*#__PURE__*/ function(Animated) {
    "use strict";
    _inherits(AnimatedValue, Animated);
    var _super = _createSuper(AnimatedValue);
    function AnimatedValue(_value) {
        _classCallCheck(this, AnimatedValue);
        var _this;
        _this = _super.call(this);
        _this.done = true;
        _this.elapsedTime = void 0;
        _this.lastPosition = void 0;
        _this.lastVelocity = void 0;
        _this.v0 = void 0;
        _this.durationProgress = 0;
        _this._value = _value;
        if (is.num(_this._value)) {
            _this.lastPosition = _this._value;
        }
        return _this;
    }
    _createClass(AnimatedValue, [
        {
            key: "getPayload",
            value: function getPayload() {
                return [
                    this
                ];
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this._value;
            }
        },
        {
            key: "setValue",
            value: function setValue(value, step) {
                if (is.num(value)) {
                    this.lastPosition = value;
                    if (step) {
                        value = Math.round(value / step) * step;
                        if (this.done) {
                            this.lastPosition = value;
                        }
                    }
                }
                if (this._value === value) {
                    return false;
                }
                this._value = value;
                return true;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var done = this.done;
                this.done = false;
                if (is.num(this._value)) {
                    this.elapsedTime = 0;
                    this.durationProgress = 0;
                    this.lastPosition = this._value;
                    if (done) this.lastVelocity = null;
                    this.v0 = null;
                }
            }
        }
    ], [
        {
            key: "create",
            value: function create(value) {
                return new AnimatedValue(value);
            }
        }
    ]);
    return AnimatedValue;
}(Animated);
var AnimatedString = /*#__PURE__*/ function(AnimatedValue) {
    "use strict";
    _inherits(AnimatedString, AnimatedValue);
    var _super = _createSuper(AnimatedString);
    function AnimatedString(value) {
        _classCallCheck(this, AnimatedString);
        var _this;
        _this = _super.call(this, 0);
        _this._string = null;
        _this._toString = void 0;
        _this._toString = createInterpolator({
            output: [
                value,
                value
            ]
        });
        return _this;
    }
    _createClass(AnimatedString, [
        {
            key: "getValue",
            value: function getValue() {
                var value = this._string;
                return value == null ? this._string = this._toString(this._value) : value;
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                if (is.str(value)) {
                    if (value == this._string) {
                        return false;
                    }
                    this._string = value;
                    this._value = 1;
                } else if (_get(_getPrototypeOf(AnimatedString.prototype), "setValue", this).call(this, value)) {
                    this._string = null;
                } else {
                    return false;
                }
                return true;
            }
        },
        {
            key: "reset",
            value: function reset(goal) {
                if (goal) {
                    this._toString = createInterpolator({
                        output: [
                            this.getValue(),
                            goal
                        ]
                    });
                }
                this._value = 0;
                _get(_getPrototypeOf(AnimatedString.prototype), "reset", this).call(this);
            }
        }
    ], [
        {
            key: "create",
            value: function create(value) {
                return new AnimatedString(value);
            }
        }
    ]);
    return AnimatedString;
}(AnimatedValue);
var TreeContext = {
    dependencies: null
};
var AnimatedObject = /*#__PURE__*/ function(Animated) {
    "use strict";
    _inherits(AnimatedObject, Animated);
    var _super = _createSuper(AnimatedObject);
    function AnimatedObject(source) {
        _classCallCheck(this, AnimatedObject);
        var _this;
        _this = _super.call(this);
        _this.source = source;
        _this.setValue(source);
        return _this;
    }
    _createClass(AnimatedObject, [
        {
            key: "getValue",
            value: function getValue(animated) {
                var values = {};
                eachProp(this.source, function(source, key) {
                    if (isAnimated(source)) {
                        values[key] = source.getValue(animated);
                    } else if (hasFluidValue(source)) {
                        values[key] = getFluidValue(source);
                    } else if (!animated) {
                        values[key] = source;
                    }
                });
                return values;
            }
        },
        {
            key: "setValue",
            value: function setValue(source) {
                this.source = source;
                this.payload = this._makePayload(source);
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.payload) {
                    each(this.payload, function(node) {
                        return node.reset();
                    });
                }
            }
        },
        {
            key: "_makePayload",
            value: function _makePayload(source) {
                if (source) {
                    var payload = new Set();
                    eachProp(source, this._addToPayload, payload);
                    return Array.from(payload);
                }
            }
        },
        {
            key: "_addToPayload",
            value: function _addToPayload(source) {
                if (TreeContext.dependencies && hasFluidValue(source)) {
                    TreeContext.dependencies.add(source);
                }
                var payload = getPayload(source);
                if (payload) {
                    var _this = this;
                    each(payload, function(node) {
                        return _this.add(node);
                    });
                }
            }
        }
    ]);
    return AnimatedObject;
}(Animated);
var AnimatedArray = /*#__PURE__*/ function(AnimatedObject) {
    "use strict";
    _inherits(AnimatedArray, AnimatedObject);
    var _super = _createSuper(AnimatedArray);
    function AnimatedArray(source) {
        _classCallCheck(this, AnimatedArray);
        return _super.call(this, source);
    }
    _createClass(AnimatedArray, [
        {
            key: "getValue",
            value: function getValue() {
                return this.source.map(function(node) {
                    return node.getValue();
                });
            }
        },
        {
            key: "setValue",
            value: function setValue(source) {
                var payload = this.getPayload();
                if (source.length == payload.length) {
                    return payload.map(function(node, i) {
                        return node.setValue(source[i]);
                    }).some(Boolean);
                }
                _get(_getPrototypeOf(AnimatedArray.prototype), "setValue", this).call(this, source.map(makeAnimated));
                return true;
            }
        }
    ], [
        {
            key: "create",
            value: function create(source) {
                return new AnimatedArray(source);
            }
        }
    ]);
    return AnimatedArray;
}(AnimatedObject);
function makeAnimated(value) {
    var nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
    return nodeType.create(value);
}
function getAnimatedType(value) {
    var parentNode = getAnimated(value);
    return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var withAnimated = function(Component, host) {
    var hasInstance = !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return /*#__PURE__*/ forwardRef(function(givenProps, givenRef) {
        var instanceRef = useRef(null);
        var ref = hasInstance && useCallback(function(value) {
            instanceRef.current = updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        var ref1 = _slicedToArray(getAnimatedState(givenProps, host), 2), props = ref1[0], deps = ref1[1];
        var forceUpdate = useForceUpdate();
        var callback = function() {
            var instance = instanceRef.current;
            if (hasInstance && !instance) {
                return;
            }
            var didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) {
                forceUpdate();
            }
        };
        var observer1 = new PropsObserver(callback, deps);
        var observerRef = useRef();
        useLayoutEffect(function() {
            observerRef.current = observer1;
            each(deps, function(dep) {
                return addFluidObserver(dep, observer1);
            });
            return function() {
                if (observerRef.current) {
                    each(observerRef.current.deps, function(dep) {
                        return removeFluidObserver(dep, observerRef.current);
                    });
                    raf.cancel(observerRef.current.update);
                }
            };
        });
        useEffect(callback, []);
        useOnce(function() {
            return function() {
                var observer = observerRef.current;
                each(observer.deps, function(dep) {
                    return removeFluidObserver(dep, observer);
                });
            };
        });
        var usedProps = host.getComponentProps(props.getValue());
        return /*#__PURE__*/ React.createElement(Component, _extends({}, usedProps, {
            ref: ref
        }));
    });
};
var PropsObserver = /*#__PURE__*/ function() {
    "use strict";
    function PropsObserver(update, deps) {
        _classCallCheck(this, PropsObserver);
        this.update = update;
        this.deps = deps;
    }
    _createClass(PropsObserver, [
        {
            key: "eventObserved",
            value: function eventObserved(event) {
                if (event.type == "change") {
                    raf.write(this.update);
                }
            }
        }
    ]);
    return PropsObserver;
}();
function getAnimatedState(props, host) {
    var dependencies = new Set();
    TreeContext.dependencies = dependencies;
    if (props.style) props = _extends({}, props, {
        style: host.createAnimatedStyle(props.style)
    });
    props = new AnimatedObject(props);
    TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function updateRef(ref, value) {
    if (ref) {
        if (is.fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
var cacheKey = Symbol.for("AnimatedComponent");
var createHost = function(components) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = ref.applyAnimatedValues, _applyAnimatedValues = tmp === void 0 ? function() {
        return false;
    } : tmp, tmp1 = ref.createAnimatedStyle, _createAnimatedStyle = tmp1 === void 0 ? function(style) {
        return new AnimatedObject(style);
    } : tmp1, tmp2 = ref.getComponentProps, _getComponentProps = tmp2 === void 0 ? function(props) {
        return props;
    } : tmp2;
    var hostConfig = {
        applyAnimatedValues: _applyAnimatedValues,
        createAnimatedStyle: _createAnimatedStyle,
        getComponentProps: _getComponentProps
    };
    var animated = function(Component) {
        var displayName = getDisplayName(Component) || "Anonymous";
        if (is.str(Component)) {
            Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
        } else {
            Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
        }
        Component.displayName = "Animated(".concat(displayName, ")");
        return Component;
    };
    eachProp(components, function(Component, key) {
        if (is.arr(components)) {
            key = getDisplayName(Component);
        }
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var getDisplayName = function(arg) {
    return is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;
};
export { Animated, AnimatedArray, AnimatedObject, AnimatedString, AnimatedValue, createHost, getAnimated, getAnimatedType, getPayload, isAnimated, setAnimated };
